import Footer from '@components/Footer/Footer';
import Hero from '@components/Hero/Hero';
import type { NextPage } from 'next';

const Home: NextPage = () => {
  return (
    <>
      <Hero />
      <Footer />
    </>
  );
};

export default Home;
